/*=========================================================================================
  File Name: module-invoice-check-history-state.js
  Description: InvoiceCheckHistory Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
export default {
	InvoiceCheckHistorys: []
};
